import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { updateEmpleado, deleteEmpleado, tomarHuellaEmpleado } from '../../../controller/empleadoController';
import { fetchSucursal } from '../../../controller/sucursalController';
import Empleado from '../../../models/Empleado';
import { fetchTurnosSemanales } from '../../../controller/TurnoController';
import { Modal, Spinner } from 'react-bootstrap';
import { fetchComando } from '../../../controller/comandoController';


function EmpleadosEditView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [empleado, setEmpleado] = useState(new Empleado(location.state?.equipo || {}));
  const [sucursalNombre, setSucursalNombre] = useState(''); // Aquí se guardará el nombre de la sucursal
  const [turnos, setTurnos] = useState([]);
  
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('Preparando lector...');
  const [checkingComando, setCheckingComando] = useState(false);

  useEffect(() => {
    const obtenerSucursal = async () => {
      try {
        if (empleado.sucursal) {
          const sucursalData = await fetchSucursal(empleado.sucursal);
          setSucursalNombre(sucursalData.name); // Ajusta si el campo se llama diferente
        }
      } catch (error) {
        console.error('Error al obtener la sucursal del empleado:', error);
      }
    };
    obtenerSucursal();
  }, [empleado.sucursal]);
useEffect(() => {
  const obtenerTurnos = async () => {
    try {
      const turnosData = await fetchTurnosSemanales();
      setTurnos(turnosData);

      // Si el empleado no tiene turno asignado, se le asigna el primero
      if (!empleado.turno_semanal && turnosData.length > 0) {
        setEmpleado((prevEmpleado) => ({
          ...prevEmpleado,
          turno_semanal: turnosData[0].id,
        }));
      }
    } catch (error) {
      console.error('Error al obtener los turnos semanales:', error);
    }
  };

  obtenerTurnos();
}, [empleado.turno_semanal]);

const handleTomarHuella = async () => {
  try {
    setShowModal(true);
    setModalMessage('Preparando lector...');
    const comandoId = await tomarHuellaEmpleado(empleado.id);

    let timeElapsed = 0;
    const interval = 5000; // 5 segundos
    const maxTime = 90000; // 1:30 minutos

    setCheckingComando(true);

    const intervalId = setInterval(async () => {
      timeElapsed += interval;

      try {
        await fetchComando(comandoId); // Si existe, seguimos esperando
      } catch (error) {
        if (error.response?.status === 404) {
          // Comando ya no está → fue procesado
          clearInterval(intervalId);
          setCheckingComando(false);
          setModalMessage('Equipo listo. Ponga el dedo 3 veces en el lector de huella.');
          return;
        }
        console.error('Error al verificar comando:', error);
      }

      if (timeElapsed >= maxTime) {
        clearInterval(intervalId);
        setCheckingComando(false);
        setModalMessage('Ocurrió un error. Verifique si el lector de huella está encendido.');
      }
    }, interval);
  } catch (error) {
    console.error('Error al tomar huella:', error);
    setModalMessage('Error al crear comando para tomar huella.');
    setShowModal(true);
  }
};



  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmpleado({
      ...empleado,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedData = { ...empleado };

    try {
      console.log(updatedData)
      await updateEmpleado(empleado.id, updatedData);
      navigate(-1);
    } catch (error) {
      console.error('Error al actualizar el empleado:', error);
    }
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este empleado? Esta acción no se puede deshacer.');
    if (confirmDelete) {
      try {
        await deleteEmpleado(empleado.id);
        navigate(-1);
      } catch (error) {
        console.error('Error al eliminar el empleado:', error);
      }
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Editar Empleado</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={empleado.nombre}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Cedula</Form.Label>
          <Form.Control
            type="text"
            name="cedula"
            value={empleado.cedula}
            onChange={handleChange}
            required
          />
        </Form.Group>


        <Form.Group className="mb-3">
          <Form.Label>UID</Form.Label>
          <Form.Control
            type="number"
            name="uid"
            value={empleado.uid}
            onChange={handleChange}
            disabled
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Posicion</Form.Label>
          <Form.Control
            type="text"
            name="posicion"
            value={empleado.posicion}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>User ID</Form.Label>
          <Form.Control
            type="text"
            name="user_id"
            value={empleado.user_id}
            onChange={handleChange}
            disabled
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Privilegio</Form.Label>
          <Form.Select
            name="privilegio"
            value={empleado.privilegio}
            onChange={handleChange}
          >
            <option value={1}>Usuario</option>
            <option value={2}>Administrador</option>
          </Form.Select>
        </Form.Group>


        <Form.Group className="mb-3">
          <Form.Label>Sucursal</Form.Label>
          <Form.Control
            type="text"
            value={sucursalNombre}
            disabled
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Turno Semanal</Form.Label>
          <Form.Control
            as="select"
            name="turno_semanal"
            value={empleado.turno_semanal}
            onChange={handleChange}
            
          >
            {turnos.length === 0 ? (
              <option value="">Cargando turnos...</option>
            ) : (
              turnos.map((turno) => (
                <option key={turno.id} value={turno.id}>
                  {turno.nombre}
                </option>
              ))
            )}
          </Form.Control>
        </Form.Group>


        <Button variant="primary" type="submit" className="me-2">
          Guardar Cambios
        </Button>

        <Button variant="secondary" onClick={() => navigate(-1)} className="me-2">
          Volver
        </Button>

        <Button variant="secondary"  onClick={handleTomarHuella}>
          Tomar Huella
        </Button>

        <Button variant="danger" onClick={handleDelete}>
          Eliminar
        </Button>
      </Form>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Tomar Huella</Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
    {checkingComando && <Spinner animation="border" className="mb-3" />}
    <p>{modalMessage}</p>
  </Modal.Body>
  {!checkingComando && (
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShowModal(false)}>
        Cerrar
      </Button>
    </Modal.Footer>
  )}
</Modal>

    </Container>
    
  );
}

export default EmpleadosEditView;
